import { Page } from '@/core/architecture'

import { CampaignDetailTemplate } from './template'
import { useViewModel } from './viewModel'

export const CampaignDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <CampaignDetailTemplate state={state} {...actions} />
}
